import { faSolidIcons } from '@/common/font-awesome/fa-solid-icons.ts';
import { faRegularIcons } from '@/common/font-awesome/fa-regular-icons.ts';
import { faCustomIcons } from '@/common/font-awesome/fa-custom-icons.ts';
import type { CustomIconDefinition } from '@/common/custom-icons.ts';

export const faIcons: CustomIconDefinition[] = [...faRegularIcons, ...faSolidIcons, ...faCustomIcons];
